export const getTooltipContent = (
	otherCRMConnected: boolean,
	accountConnected: boolean,
	legacyConnected: boolean,
	isAdmin: boolean,
	adminFullName: string,
): string => {
	if (otherCRMConnected) {
		return "You can only have one CRM integration connected at a given time.";
	} else if (!(accountConnected || legacyConnected)) {
		if (isAdmin) {
			return "This integration requires configuration by a Super admin at the \
				HubSpot level. Head to workspace settings.";
		} else {
			return `This integration requires configuration at the workspace level. Please \
				reach out to your workspace administrator, ${adminFullName}.`;
		}
	}

	return "";
};
